class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.overlay = this.querySelector('.mega-menu__overlay');

    this.overlay?.addEventListener('click', () => this.close());

    if (window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('mouseenter', this.onPointerEnter.bind(this));
      this.addEventListener('mouseleave', this.onPointerLeave.bind(this));
      this.overlay?.addEventListener('mouseenter', this.onPointerLeave.bind(this));
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  onPointerEnter() {
    clearTimeout(this.leaveTimer);
    this.enterTimer = setTimeout(() => this.open(), 150);
  }

  onPointerLeave() {
    clearTimeout(this.enterTimer);
    this.leaveTimer = setTimeout(() => this.close(), 200);
  }

  // A click right after the hover opened the panel would toggle it shut again.
  onSummaryClick(event) {
    if (Date.now() - (this.openedByHoverAt || 0) > 400) return;
    event.preventDefault();
    setTimeout(() => this.summary.setAttribute('aria-expanded', true));
  }

  open() {
    if (this.mainDetailsToggle.open) return;
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    this.openedByHoverAt = Date.now();
  }

  close() {
    clearTimeout(this.enterTimer);
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
